import { render } from "./ServiceJobCategoriesView.vue?vue&type=template&id=353c6426&ts=true"
import script from "./ServiceJobCategoriesView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobCategoriesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__